/**
 * CARTIEAI changelog — bump `CHANGELOG_VERSION` whenever you add a new entry
 * to show a "new" dot next to the logo for all existing users.
 */

export const CHANGELOG_VERSION = '2026.02.21-final';

export const CHANGELOG = [
  {
    version: '2026.02.21-final',
    date: 'Feb 21, 2026',
    title: 'Landing polish + Google SSO live',
    highlight: 'Production-ready',
    items: [
      { emoji: '🚀', text: 'Google Workspace SSO is now LIVE — sign in with one click' },
      { emoji: '💫', text: 'Smooth 15-cloud scrolling marquee replaces the static provider chips' },
      { emoji: '✨', text: 'Staggered fade-in animation on the 13 killer features' },
      { emoji: '🧼', text: 'Cleaner signup — no more role dropdown, just Name / Email / Password' },
    ],
  },
  {
    version: '2026.02.21-polished',
    date: 'Feb 21, 2026',
    title: 'Landing polish + compact cloud picker',
    highlight: 'Ship-ready',
    items: [
      { emoji: '🎨', text: 'Cloud picker is now a sleek dropdown with chips — not a long list anymore' },
      { emoji: '💫', text: 'New 15-cloud animated trust strip on the landing page' },
      { emoji: '📊', text: 'ROI calculator works for any mix of clouds (AWS + Oracle? we got you)' },
      { emoji: '✨', text: 'Removed every "Coming Soon" — only live features shown' },
    ],
  },
  {
    version: '2026.02.21-multicloud',
    date: 'Feb 21, 2026',
    title: 'All 15 clouds, everywhere',
    highlight: 'Personalised to your stack',
    items: [
      { emoji: '☁️', text: 'Pick any of 15 clouds — AWS, Azure, GCP, Oracle, IBM, Alibaba, Databricks, DigitalOcean, Cloudflare, and 6 more' },
      { emoji: '🎯', text: 'Dashboards now show ONLY the clouds you use — no more irrelevant AWS tiles if you run Oracle' },
      { emoji: '🔎', text: 'New searchable cloud picker with grouped tiers (Major / Enterprise / Data / Growth / Specialty)' },
      { emoji: '⚙️', text: 'Change your clouds anytime from Settings → Your Clouds' },
    ],
  },
  {
    version: '2026.02.21',
    date: 'Feb 21, 2026',
    title: 'Enterprise-ready release',
    highlight: 'SSO + cleaner navigation',
    items: [
      { emoji: '🔐', text: 'Real OAuth 2.0 / OIDC sign-in for Google Workspace, Microsoft Entra ID, and Okta' },
      { emoji: '📅', text: '15-min founder call booking on the landing page (Cal.com integrated)' },
      { emoji: '🎨', text: 'Cleaner navigation — 5 focused items, Snowflake tools now live under Analytics & Optimize' },
      { emoji: '⚡', text: '"Founders online" presence indicator to show real humans are on the other end' },
    ],
  },
  {
    version: '2026.02.20',
    date: 'Feb 20, 2026',
    title: 'Real Cloud Audit for all 3 clouds',
    highlight: 'AWS + Azure + GCP live',
    items: [
      { emoji: '☁️', text: 'Azure Cost Management API integration (tenant + client + secret)' },
      { emoji: '📊', text: 'GCP billing API integration (service account JSON)' },
      { emoji: '📎', text: 'CSV billing file fallback — upload and get savings in 60 seconds' },
      { emoji: '🪪', text: '"Enterprise SSO is LIVE" badge on the pricing page' },
    ],
  },
  {
    version: '2026.02.18',
    date: 'Feb 18, 2026',
    title: '14 killer FinOps features',
    highlight: 'Fortune 500 grade',
    items: [
      { emoji: '🔬', text: 'Invoice Autopsy — AI bill explainer' },
      { emoji: '🕵️', text: 'SaaS Detective — find hidden subscriptions' },
      { emoji: '🎯', text: 'Board Deck Generator — CFO-ready presentations in one click' },
      { emoji: '🤝', text: 'Vendor Deal Intel — contract negotiation intelligence' },
      { emoji: '🛡️', text: 'Compliance Mapper — SOC 2 / ISO / GDPR audit evidence' },
    ],
  },
];
